import styled from "styled-components";

export const StylesTeacherCalendar = styled.div`
  background-color: #f5f5f5;
  padding: 24px 24px 0px 24px;
  .calendar-container {
    background-color: #ffffff;
    border-radius: 16px;
    padding: 16px;
    cursor: auto;
  }
  .user-profile {
    margin-bottom: 16px;
    img {
      width: 150px;
      border-radius: 50%;
    }
    @media only screen and (max-width: 600px) {
      width: 75px;
    }
    p {
      font-size: 30px;
      font-weight: medium;
      margin-left: 10px;
    }
  }
`;
